import { useState } from 'react';
import { Modal, Button, Typography, message } from 'antd';
import { GiftOutlined, CheckCircleFilled } from '@ant-design/icons';
import useActiveAccount from '../../hooks/useActiveAccount';
import useClaimOffers from '../../hooks/useClaimOffers';
import { HUBSPOT_INSTALL_GUIDE_URL } from '../../constants/hubspotGuides';
import InstallGuideSteps from './InstallGuideSteps';
import './claimOfferModal.css';

const { Title, Paragraph } = Typography;

const ClaimOfferModal = () => {
  const { clientInfo } = useActiveAccount();
  const { pendingOffer, claiming, claim, dismiss } = useClaimOffers(clientInfo);
  const [claimed, setClaimed] = useState(false);

  // claim() pone pendingOffer en null al tener éxito (para no reofrecerla);
  // seguimos montados mientras se muestra la pantalla de éxito.
  if (!pendingOffer && !claimed) return null;

  const handleClaim = async () => {
    try {
      await claim();
      setClaimed(true);
    } catch {
      message.error('No pudimos activar tu regalo. Intenta de nuevo en unos segundos.');
    }
  };

  const handleClose = () => {
    setClaimed(false);
    dismiss();
  };

  return (
    <Modal
      open
      onCancel={handleClose}
      footer={null}
      centered
      width={claimed ? 820 : 440}
      maskClosable={!claiming}
      closable={!claiming}
      destroyOnClose
    >
      <div className="claim-offer-modal">
        {!claimed ? (
          <>
            <div className="claim-offer-modal__icon claim-offer-modal__icon--gift">
              <GiftOutlined />
            </div>
            <Title level={4} style={{ textAlign: 'center', marginBottom: 8 }}>
              {pendingOffer.title || '¡Tienes una oferta disponible!'}
            </Title>
            {pendingOffer.description && (
              <Paragraph type="secondary" style={{ textAlign: 'center' }}>
                {pendingOffer.description}
              </Paragraph>
            )}
            <Button
              type="primary"
              size="large"
              block
              loading={claiming}
              onClick={handleClaim}
              style={{ marginTop: 8 }}
            >
              Reclamar
            </Button>
          </>
        ) : (
          <div className="claim-offer-modal__success">
            <div className="claim-offer-modal__confetti">
              {Array.from({ length: 10 }).map((_, i) => (
                <span key={i} className={`claim-offer-modal__confetti-piece piece-${i}`} />
              ))}
            </div>
            <div className="claim-offer-modal__icon claim-offer-modal__icon--check">
              <CheckCircleFilled />
            </div>
            <Title level={4} style={{ textAlign: 'center', marginBottom: 8 }}>
              ¡Listo! Ya está activo
            </Title>
            <Paragraph type="secondary" style={{ textAlign: 'center', marginBottom: 12 }}>
              Para empezar a usarlo, sigue estos pasos de instalación de HubSpot: conectar
              WhatsApp y activar tu agente virtual.
            </Paragraph>

            <div className="claim-offer-modal__guide-steps">
              <InstallGuideSteps onNavigateInternal={handleClose} />
            </div>

            <Paragraph type="secondary" style={{ fontSize: 12, marginTop: 12, marginBottom: 0 }}>
              ¿Prefieres verla en la página original?{' '}
              <a href={HUBSPOT_INSTALL_GUIDE_URL} target="_blank" rel="noopener noreferrer">
                Ábrela en una pestaña nueva
              </a>.
            </Paragraph>

            <Button type="primary" block onClick={handleClose} style={{ marginTop: 12 }}>
              Cerrar
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ClaimOfferModal;
